// extracted by mini-css-extract-plugin
export default {"text":"title-module--text--c9ce5","picture":"title-module--picture--9dcd5"};